 <template>
    <gj-modal size="700x450" v-on="$listeners" v-bind="$attrs"  confirmText = "知道了" :visible.sync="modalVisible"
        class="instructions-table">
        <template #header>关怀邮件使用说明</template>
        <template #content>
            <div class="content">
                <div>
                    根据亚马逊2019年12月3日针对站内信的新政策，官方对站内信（邮件）索评的方式作出了更严格的规定。 <span style="font-weight: bold;color:#000">您仅能为了完成订单或回复顾客的询问联系买家，您不能为了营销或促销而联系买家</span>
                    (包括经由邮件、实体信件、电话或是其他联络方式) ，使用请注意以下几点：</div>

                <p>1. 若非必要情况，请勿使用"[remove，delete，update，feedback，review，comment，promotion, free,
                    cheap、important、addition、information]”敏感词汇。</p>

                <p>2. 请勿添加营销促销信息。</p>

                <p>3. 请勿使用奖励或者引导用户只留好评。</p>

                <p>4. 请勿要求客户移除或修改评论。</p>

                <p>5. 请勿添加与完成订单无关的链接、附件等信息，包括退订站内信的链接、商标、亚马逊站外链接。</p>

                <p>6. 请勿通往任何亚马逊详细页面或店面的链接，以及包含或显示链接通往卖家网站的商标。</p>

                <p>7. 请勿任何其他产品的促销活动或是取得第三方产品或促销活动的方式。</p>

                <p>8. 在任何情况下，我方不对因使用本功能造成直接、间接、附带性或结果性损失负责，使用者自行承担损失与责任。</p>
            </div>
        </template>
        </gj-modal>
</template>

<script>
import { modalMixIn } from "./../../../../../minxins";
export default {
    name: "send-rule-instructions-table",
    mixins: [modalMixIn],
    data() {
        return {
            data: [],
        }
    },
}
</script>

<style lang="scss">
.instructions-table {
    div.el-dialog {
        width: 700px !important;
        height: 450px !important;
    }
    .content {
        padding: 18px 20px 0;
        box-sizing: border-box;
        font-size: 12px;
        color: #333;
        line-height: 18px;
    }
}

</style>
